/**************************************************
 * Nombre:       Dialogo_Politica
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Grid2} from "@mui/material";
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

const Dialogo_Politica = ({datos}) => {

    const htmlFrom = (htmlString) => {
        const cleanHtmlString = DOMPurify.sanitize(htmlString,
            {USE_PROFILES: {html: true}});
        const html = parse(cleanHtmlString);
        return html;
    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                {htmlFrom(datos?.textoEstilo)}
            </Grid>

        </Grid>
    )

}
export default Dialogo_Politica